import React, { memo, useEffect } from "react";
import st from "../../styles/template.module.scss";
import Input from "../../components/Input/Input";

function PriceOptionsLine({ obj, onChangeLine, value = '' }: any) {
    return (
        <div className={st.vertical}>
            <label className={st.label}>{obj.name}</label>
            <Input name={obj.code} value={value} isReadOnly={false} placeholder="Number"
                inputValidate={'onlyNumbers'}
                onChange={(e) => onChangeLine(e.target.name, e.target.value)}
                ico={obj.name == 'Deposit' ? 'clock' : 'blank'}
            />
        </div>
    );
}

export default memo(PriceOptionsLine);